import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { useLocation } from "react-router-dom";

const AddReceipt = ({
  PhysicalStockinId,
  vendorId,
  itemNameData,
  isEdit,

  isSerailDrawerOpen,
  serialData,
  businessPartnerIdState
}) => {
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const [userTypedd, setUserTypedd] = useState([]);
  const [iseditmode, setisEditMode] = useState(false);
  const [serialList, setSerialList] = useState([]);
  const userType = localStorage.getItem("UserType");
  const [variantId, setVariantId] = useState(0);
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const token = localStorage.getItem("authToken");
  const location = useLocation();
  console.log("seraillocationdata", serialData);
  const [serialID,setSerialId] = useState(null)


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchDepartments(newPage);
  };
  const fetchDepartments = async (page = 0, pageSize = 10) => {
    try {
      const response = await axiosInstance.post(
        "/physicalstocktakeitemserial/list",
        {
          orderBy: "phystockinsr_id desc",
          page,
          pageSize,
          phystkinitem_id: serialData?.phystkin_item_id,
          phystkin_id: PhysicalStockinId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      setTotalRecords(totalRecordsData);

      setSerialList(formattedData);
      
      console.log("response", response);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
  };
  useEffect(() => {
    userTypedropdown();
    if(isSerailDrawerOpen){
      fetchDepartments();
      setValidationErrors({})
    }
   
  }, [isSerailDrawerOpen]);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };
  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    VehicleInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    setIsLoading(true);
    console.log("formData", formData, isEdit);

    try {
      if (iseditmode) {
        const payload = {
          phystkin_id: serialData?.phystkin_id,
          itemtype: serialData?.itemtype,
          phystkinitem_id: serialData?.phystkin_item_id,
          chassis_no: itemNameData === "Vehicle" ? formData?.chassisno : null,
          engine_no: itemNameData === "Vehicle" ? formData?.engineno : null,
          bar_code: null,
          serial_no: formData?.serialno,
          business_partner_id:businessPartnerIdState
        };

        // if (userType === "superadmin") {
        //   payload.business_partner_id = formData.business_partner_id;
        // } else {
        //   payload.business_partner_id = businessPartnerId;
        // }

        const response = await axiosInstance.patch(
          `/physicalstocktakeitemserial/update/${serialID}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("Unit added successfully:", response.data);
        fetchDepartments();
        setFormData({})
        setisEditMode(false)
      } else {
        const payload = {
          phystkin_id: serialData?.phystkin_id,
          itemtype: serialData?.itemtype,
          phystkinitem_id: serialData?.phystkin_item_id,
          chassis_no: itemNameData === "Vehicle" ? formData?.chassisno : null,
          engine_no: itemNameData === "Vehicle" ? formData?.engineno : null,
          bar_code: null,
          serial_no: formData?.serialno,
          business_partner_id:businessPartnerIdState
        };

        // if (userType === "superadmin") {
        //   payload.business_partner_id = formData.business_partner_id;
        // } else {
        //   payload.business_partner_id = businessPartnerId;
        // }

        const response = await axiosInstance.post(
          "/physicalstocktakeitemserial/create",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("Unit added successfully:", response.data);
        fetchDepartments();
        setFormData({});
      }

      //navigate('/logistics/manage-stock/physical-stock-taking');
    } catch (error) {
      console.error("Error adding data:", error);

      console.error("Error submitting form:", error);
    } finally {
      setIsLoading(false);
    }
    console.log("clicked");
  };

  const VehicleInputs = [

    {
      name: "search",
      label: "Search",
      type: "text",
      placeholder: "Enter Serial No.",
      validation: { required: true },
      required: true,
      gridClass: "col-lg-12",
    },
    {
        name: "transactionno",
        label: "Transaction No.",
        type: "text",
        placeholder: "Enter Transaction No.",
        validation: { required: true },
        required: true,
        gridClass: "col-lg-12",
      },
      {
        name: "transactiondate",
        label: "Transaction Date",
        type: "date",
        placeholder: "Enter Transaction Date",
        validation: { required: true },
        required: true,
        gridClass: "col-lg-12",
      },
      {
        name: "paymentof",
        label: "Payment Of",
        type: "dropdown",
        options:[{label:"Paid" ,value:"Paid"},
            {label:"UnPaid" ,value:"unPaid"},],
        validation: { required: true },
        required: true,
        gridClass: "col-lg-12",
      },
  ];
  
  useEffect(() => {
    const fetchSparePartExistingDetails = async () => {
      console.log("serialData",serialData);

      try {
        const response = await axiosInstance.get(
          `/physicalstocktakeitemserial/edit/${serialID}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          const vehicleData = response.data.data;
          console.log("vehicledata", vehicleData, response);

          const transformedData = {
            business_partner_id: vehicleData?.business_partner_id,
            chassisno: vehicleData.chassis_no,
            engineno: vehicleData.engine_no,
            serialno: vehicleData?.serial_no,
          };

          setFormData(transformedData);

          console.log(
            "Transformed vehicle data set to formData:",
            transformedData
          );
        } else {
          console.error("Failed to fetch vehicle data");
        }
      } catch (error) {
        console.error("Error fetching vehicle data:", error);
      }
    };

    if (iseditmode) {
      console.log("iseditmode", iseditmode);

      fetchSparePartExistingDetails();
    }
  }, [iseditmode]);
 
  

  return (
    <div className="mt-1 mb-3">
      <DynamicForm
        formConfig={VehicleInputs}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
      />
      <div className="btncontainer mt-3 gap-2">
        {/* <button style={{backgroundColor:"#fff", padding:"10px 20px" , borderRadius:"10px", color:"#7BD755", border:"1px solid #7BD755"}}>
            Back
        </button> */}
        <button
          onClick={() => handleFormSubmit(formData)}
          className="submit-btn"
        >
          {iseditmode ? "Update" : "Submit"}
        </button>
      </div>
     
    </div>
  );
};

export default AddReceipt;
